import React from 'react';
import classNames from 'classnames';
import { Redirect } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, Nav } from 'reactstrap';
import PropTypes from 'prop-types';

import { AppHeaderDropdown, AppSidebarToggler, AppNavbarBrand } from '@coreui/react';

import { SignOut } from 'aws-amplify-react-custom';
//import sygnet from '../../assets/img/brand/sygnet.svg';
let logo = null;
if (process.env.REACT_APP_LOGO !== 'none') {
 logo = require(`../../assets/${process.env.REACT_APP_CUSTOMER}/img/brand/${process.env.REACT_APP_LOGO}`);
}
const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class SidebarToggler extends AppSidebarToggler {
  render () {
    const { className, children, tag: Tag, ...attributes } = this.props;

    delete attributes.mobile
    delete attributes.display

    const classes = classNames(className, 'navbar-toggler');
    return (
      <Tag type="button" className={classes} {...attributes} onClick={(event)=>this.sidebarToggle(event)} data-sidebar-toggler>
        {children || <i className="fas fa-bars text-secondary"></i>}
      </Tag>
    );
  }
}


class DefaultHeader extends SignOut {

  logout = () => {
    this.signOut();
  }

  render() {

    // eslint-disable-next-line
    const { authState, children, ...attributes } = this.props;

    // If authState is signedOut, redirect back to homepage
    if (authState === 'signedOut') {
      return <Redirect to='/' />
    }

    return (
      <React.Fragment>
        <SidebarToggler className="d-lg-none" display="md" mobile />
          {
           logo ?
            <AppNavbarBrand
              full={{ src: logo, width: 140, alt: 'DTCROS Logo' }}
              minimized={{ src: logo, width: 140, alt: 'DTCROS Logo' }}
            /> : null
          }
        <SidebarToggler className="d-md-down-none" display="lg" />

        <Nav className="ml-auto" navbar>
          {/*<NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-bell"></i><Badge pill color="danger">5</Badge></NavLink>
          </NavItem>
          <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-list"></i></NavLink>
          </NavItem>
          <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-location-pin"></i></NavLink>
          </NavItem>*/}
          <AppHeaderDropdown direction="down">
            <DropdownToggle nav>
              <i className="fas fa-user-circle fa-2x img-avatar"></i>
              {
                /* User image could be used instead of icon e.g
                <img src={'assets/img/avatars/6.jpg'} className="img-avatar" alt="admin@bootstrapmaster.com" />
                */
              }
            </DropdownToggle>
            <DropdownMenu right style={{ right: 'auto' }}>
              {/*<DropdownItem header tag="div" className="text-center"><strong>Account</strong></DropdownItem>
              <DropdownItem><i className="fa fa-bell-o"></i> Updates<Badge color="info">42</Badge></DropdownItem>
              <DropdownItem><i className="fa fa-envelope-o"></i> Messages<Badge color="success">42</Badge></DropdownItem>
              <DropdownItem><i className="fa fa-tasks"></i> Tasks<Badge color="danger">42</Badge></DropdownItem>
              <DropdownItem><i className="fa fa-comments"></i> Comments<Badge color="warning">42</Badge></DropdownItem>
              <DropdownItem header tag="div" className="text-center"><strong>Settings</strong></DropdownItem>
              <DropdownItem><i className="fa fa-user"></i> Profile</DropdownItem>
              <DropdownItem><i className="fa fa-wrench"></i> Settings</DropdownItem>
              <DropdownItem><i className="fa fa-usd"></i> Payments<Badge color="secondary">42</Badge></DropdownItem>
              <DropdownItem><i className="fa fa-file"></i> Projects<Badge color="primary">42</Badge></DropdownItem>
              <DropdownItem divider />
              <DropdownItem><i className="fa fa-shield"></i> Lock Account</DropdownItem>*/}
              <DropdownItem onClick={this.logout}><i className="fa fa-lock"></i> Logout</DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
        {/*<AppAsideToggler className="d-md-down-none" />*/}
        {/*<AppAsideToggler className="d-lg-none" mobile />*/}
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default DefaultHeader;
